import { NextSeo } from 'next-seo';
import CharityAbout from '../components/CharityAbout';
import CharityHero from '../components/CharityHero';
import CharityTotals from '../components/CharityTotals';
import CharityWallet from '../components/CharityWallet';
import { config } from '../config';

export default function Grub() {
  const description = ``;

  return (
    <>
      <NextSeo title={`The Gekofam & Friends Charity Wallet - ${config.siteName}`} description={description} />

      <CharityHero />
      <CharityTotals />
      <CharityAbout />
      <div className='pt-24 pb-24'>
        <CharityWallet />
      </div>
    </>
  );
}
